module.exports = __webpack_public_path__ + "img/typo-01.be70b6b3.png";